import { Component, Input } from '@angular/core';

import { bonificacao } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-bonificacao',
    templateUrl: './config-pedido-tipo-venda-badge-bonificacao.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-bonificacao.component.less']
})
export class ConfigPedidoTipoVendaBadgeBonificacaoComponent {
    tipo = bonificacao;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
